// src/components/layout/CookieConsentBanner.tsx

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

const CONSENT_KEY = 'cookie_consent_accepted';

export const CookieConsentBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem(CONSENT_KEY);
    if (!accepted) {
      // Pequeño delay para no bloquear el render inicial
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'true');
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(CONSENT_KEY, 'essential_only');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-slide-up">
      <div className="bg-[#131e3e]/95 backdrop-blur-lg border-t-2 border-[#214e80]/50 shadow-2xl shadow-black/50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 sm:py-5">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            {/* Icon + Text */}
            <div className="flex items-start gap-3 flex-1">
              <Shield className="w-5 h-5 sm:w-6 sm:h-6 text-[#10b981] flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm sm:text-base text-slate-200 leading-relaxed">
                  Utilizamos cookies y almacenamiento local para mejorar tu experiencia, mantener tu sesión activa y almacenar predicciones en caché.
                  Al continuar, aceptas nuestros{' '}
                  <Link to="/terms" className="text-[#10b981] hover:underline font-semibold">
                    Términos de Servicio
                  </Link>{' '}
                  y nuestra{' '}
                  <Link to="/privacy" className="text-[#10b981] hover:underline font-semibold">
                    Política de Privacidad
                  </Link>.
                </p>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex items-center gap-3 flex-shrink-0 w-full sm:w-auto">
              <button
                onClick={handleReject}
                className="px-4 py-2.5 text-sm font-semibold text-slate-400 hover:text-white border border-[#214e80]/50 hover:border-slate-500 rounded-lg transition-all"
              >
                Solo esenciales
              </button>
              <button
                onClick={handleAccept}
                className="flex-1 sm:flex-none px-6 py-2.5 bg-[#10b981] hover:bg-[#059669] text-white font-bold text-sm rounded-lg transition-all shadow-lg shadow-[#10b981]/20"
              >
                Aceptar todo
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
